import { Components, Theme } from '@mui/material';

export const MuiSnackbarStyle: Components<Theme>['MuiSnackbar'] = {
  styleOverrides: {
    root: {
      '.MuiAlertTitle-root': {
        margin: 0,
        lineHeight: 'normal',
      },
      '.MuiAlert-action': {
        '.MuiButtonBase-root': {
          fontSize: '13px',
        },
      },
    },
  },
};
